<template>
  <el-container>
    <!-- 头部 -->
    <el-header style="height:58px">
      <div>
        <img src="../assets/logo-dm.png" alt />
        <span>寿州农服平台端</span>
      </div>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <!-- 主体 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="togleCollapse">|||</div>
        <el-menu
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          :default-active="activePath"
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409FFF"
        >
          <!-- :unique-opened="true"->只允许展开一个菜单 -->
          <!-- :collapse-transition="false" -> 关闭动画 -->
          <!-- router -> 导航开启路由模式 -->
          <!-- 一级菜单  -->
          <template  v-for="(item, index) in menuList">
            <el-menu-item
            v-if="!item.children || !item.children.length"
            :index="'/' + item.path"
            @click="saveNavState('/' + item.path)"
          >
            <template slot="title">
              <i :class="iconObj[item.id]"></i>
              <span>{{ item.authName }}</span>
            </template>
          </el-menu-item>
          <el-submenu
            v-if="item.children && item.children.length"
            :index="item.id + ''"
          >
            <!-- 一级菜单的模板区域 -->
            <template slot="title">
              <i :class="iconObj[item.id]"></i>
              <span>{{ item.authName }}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item
              :index="'/' + subItem.path"
              v-for="subItem in item.children"
              :key="subItem.id"
              @click="saveNavState('/' + subItem.path)"
            >
              <!-- 导航开启路由模式：
                将index值作为导航路由 -->
              <!-- 二级菜单的模板区域 -->
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>{{ subItem.authName }}</span>
              </template>
            </el-menu-item>
          </el-submenu>

          </template>
          
        </el-menu>
      </el-aside>
      <!-- 内容主体 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      // 左侧菜单数据
      menuList: [],
      // 一级菜单图标映射（id -> icon class）
      iconObj: {
        100: "el-icon-odometer",   // 仪表盘
        1:   "el-icon-truck",      // 农机服务管理
        2:   "el-icon-shopping-bag-1", // 农资商城管理
        3:   "el-icon-place",      // 农场管理
        4:   "el-icon-map-location", // 土地租赁管理
        5:   "el-icon-user",       // 会员管理
        6:   "el-icon-document",   // 资讯管理
        7:   "el-icon-data-analysis", // 数据统计
        8:   "el-icon-setting",    // 系统管理
        9:   "el-icon-office-building", // 集团管理
        // cashier 菜单 id
        "cash_manage": "el-icon-money",
      },
      // 默认不折叠
      isCollapse: false,
      // 被激活导航地址
      activePath: "home",
    };
  },
  created() {
    this.activePath = window.sessionStorage.getItem("activePath");
    this.getMenuList();
  },
  methods: {
    logout() {
      window.sessionStorage.clear();
      this.$router.push("/login");
    },
    // 从后端动态获取菜单
    async getMenuList() {
      try {
        const platform = window.sessionStorage.getItem("platform") || "admin";
        const { data: res } = await this.$http.get("web_api/admin/menus", {
          params: { platform }
        });
        if (res.code !== 200) {
          this.$message.error("获取菜单失败，请重新登录");
          return;
        }
        this.menuList = res.data;
      } catch (e) {
        this.$message.error("菜单加载失败");
      }
    },
    // 菜单的折叠与展开
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 保存连接的激活地址
    saveNavState(activePath) {
      window.sessionStorage.setItem("activePath", activePath);
    },
  },
};
</script>

<style lang="less" scoped>
.el-container {
  height: 100%;
}
.el-header {
  background-color: #373f41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    img {
      height: 40px;
    }
    span {
      margin-left: 15px;
    }
  }
}
.el-aside {
  background-color: #333744;

  .el-menu {
    border: none;
  }
}
.el-main {
  background-color: #eaedf1;
}
.iconfont {
  margin-right: 10px;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  // 鼠标放上去变成小手
  cursor: pointer;
}
</style>
